module.exports = __webpack_public_path__ + "img/dibu3.f2c3b8a7.png";